import { connect } from 'react-redux';

import {
  setDialogSelfAuthorization,
  setSelfAuthorizationDialogOpen,
} from '../../../store/selfAuthorizationsSlice';

import CardButtonSelect from './ButtonSelect';

const mapDispatch = {
  setDialogSelfAuthorization,
  setSelfAuthorizationDialogOpen,
};

export default connect(null, mapDispatch)(CardButtonSelect);
